import ModalController from "../modal_controller"
import { showNotification } from "./../helpers"

// Modal dwukrokowy dla bramki płatniczej kontrahenta (IPKSeF), która nie oznaczy nam faktury jako opłaconej.
// Trigger: link z data-ipksef-pay-confirm; krok 1 prowadzi do bramki linkiem gatewayLink
// (prawdziwy <a target="_blank"> — kliknięcia w linki nie podlegają popup blockerom), krok 2 pozwala potwierdzić płatność.
export default class extends ModalController {
  static targets = [...ModalController.targets, "step1", "step2", "gatewayLink"]
  static values = { errorMessage: String }

  paidUrl = null

  open(event) {
    event.preventDefault()
    this.gatewayLinkTarget.href = event.currentTarget.getAttribute("href")
    this.paidUrl = event.currentTarget.dataset.ipksefPaidUrl
    this.step1Target.classList.remove("hidden")
    this.step2Target.classList.add("hidden")
    super.open()
  }

  next() {
    this.step1Target.classList.add("hidden")
    this.step2Target.classList.remove("hidden")
  }

  confirm() {
    if (this.step1Target.classList.contains("hidden")) return

    this.gatewayLinkTarget.click()
  }

  async markPaid() {
    if (!this.paidUrl) return

    try {
      const response = await fetch(this.paidUrl, {
        method: "POST",
        headers: { "X-CSRF-Token": this.csrfToken }
      })
      if (response.ok) {
        window.location.reload()
      } else {
        const data = await response.json().catch(() => null)
        showNotification(data?.message || this.errorMessageValue)
      }
    } catch {
      showNotification(this.errorMessageValue)
    }
  }

  get csrfToken() {
    return document.querySelector("meta[name=\"csrf-token\"]")?.getAttribute("content") || ""
  }
}
